

function removerAcentos(str) {
  return str
    .normalize('NFD') // Decomposição de caracteres
    .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
    .replace(/ç/g, 'c') // Substitui 'ç' por 'c'
    .replace(/ã/g, 'a') // Substitui 'ã' por 'a'
    .replace(/õ/g, 'o') // Substitui 'õ' por 'o'
    .replace(/á|à|ã|â|ä/g, 'a') // Substitui 'á', 'à', 'ã', 'â', 'ä' por 'a'
    .replace(/é|è|ê|ë/g, 'e') // Substitui 'é', 'è', 'ê', 'ë' por 'e'
    .replace(/í|ì|î|ï/g, 'i') // Substitui 'í', 'ì', 'î', 'ï' por 'i'
    .replace(/ó|ò|õ|ô|ö/g, 'o') // Substitui 'ó', 'ò', 'õ', 'ô', 'ö' por 'o'
    .replace(/ú|ù|û|ü/g, 'u') // Substitui 'ú', 'ù', 'û', 'ü' por 'u'
    .replace(/Á/g, 'A') // Substitui 'Á' por 'A'
    .replace(/É/g, 'E') // Substitui 'É' por 'E'
    .replace(/Í/g, 'I') // Substitui 'Í' por 'I'
    .replace(/Ó/g, 'O') // Substitui 'Ó' por 'O'
    .replace(/Ú/g, 'U') // Substitui 'Ú' por 'U'
    .replace(/Ç/g, 'C'); // Substitui 'Ç' por 'C'
}

const generateZPL = (codigoBarras, quantidade) => {
  let barCodeZPL = "";
  let count = 0;

  while (quantidade > 0) {
    if (count % 2 === 0) {
      barCodeZPL += "^XA";
      barCodeZPL += "^MMT";// Início do bloco de etiquetas
    }

    let xOffset = (count % 2) * 470; // Define a posição para a segunda coluna com mais espaço
    let yOffset = 50; // Margem de 3cm acima do código de barras

    barCodeZPL += `
    ^FO${xOffset + 20},${yOffset + 20}^BY2,2,100   
    ^B3N,N,100,Y,N       
    ^FD>:${codigoBarras}^FS  
    `;

    count++;
    quantidade--;

    if (count % 2 === 0 || quantidade === 0) {
      barCodeZPL += "^XZ"; // Fecha o bloco a cada duas etiquetas
    }
  }

  return barCodeZPL;
};




const generateZPL2 = (codigoBarras, quantidade) => {
  let barCodeZPL = "";
  while (quantidade > 0) {
    barCodeZPL += `
    ^XA                ; Início do comando ZPL
    ^PW400          ; Largura da etiqueta (50mm = 400 pontos em 203 DPI)
    ^LL240          ; Altura da etiqueta (30mm = 240 pontos em 203 DPI)

    ; Definindo a posição e o código de barras
    ^FO20,20^BY2,2,100   ; Posição do código de barras, largura das barras 2, densidade 3, altura 100
    ^B3N,N,100,Y,N       ; Code 128, com 100 de altura, sem texto abaixo
    ^FD>:${codigoBarras}^FS  ; Código de barras com prefixo ">" para alfanumérico

^XZ                ; Fim do comando ZPL
      `;

    quantidade--;
  }
  return barCodeZPL;
};

export default generateZPL;
